import type { FeedatyAverageReviewsData, FeedatyResponse } from 'shared/types/Feedaty';
import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';

const useAverageRatings = (productKey?: string) => {
  const sdk = useSdk();
  const result = useSWR(
    ['/action/feedaty/getAverageRatings', productKey],
    () => {
      return sdk.callAction<FeedatyResponse<FeedatyAverageReviewsData>>({
        actionName: 'feedaty/getAverageRatings',
        payload: { sku: productKey },
      });
    },
    revalidateOptions,
  );

  return result.data?.isError
    ? { count: 0, rating: 0 }
    : {
        count: result.data?.data.Data.Products?.RatingsCount || 0,
        rating: result.data?.data.Data.Products?.AverageValue || 0,
      };
};

export default useAverageRatings;
